import React, { useEffect } from 'react';
import { styled } from 'storybook/theming';

import { LoadingOutlined } from '@ant-design/icons';

import StatusCell from '../../../components/Badge/StatusCell';
import BAVerificationStatsCard from '../../../components/Cards/BAVerificationStatsCard';
import BAConfirmDriverIcon from '../../../components/Icons/BAConfirmDriverIcon';
import BADriverInfoIcon from '../../../components/Icons/BADriverInfoIcon';
import BARejectDriverIcon from '../../../components/Icons/BARejectDriverIcon';
import ExclaimIcon from '../../../components/Icons/ExclaimIcon';
import ShieldIcon from '../../../components/Icons/ShieldIcon';
import IndicateIssuesModal from '../../../components/Modal/ModalActions/IndicateIssuesModal/IndicateIssuesModal';
import VerifyNINModal from '../../../components/Modal/ModalActions/VerifyNINModal/VerifyNINModal';
import Table from '../../../components/Table/Table';
import ActionRow from '../../../components/Table/TableAccessories/ActionRow';
import ActionRowWithModal from '../../../components/Table/TableAccessories/ActionRowWithModal';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import TableFirstAndLastNameFormatter from '../../../components/Table/TableAccessories/TableFirstAndLastNameFormatter';
import TablePhoneFormatter from '../../../components/Table/TableAccessories/TablePhoneFormatter';
import ViewDetails from '../../../components/Table/TableAccessories/ViewDetails';
import BAFilterForm from '../../../components/Table/TableFilterForms/BAFilterForm';
import ViewBADriverInfoCell from '../../../components/Table/TableMobileRowCell/ViewBADriverInfoCell';
import ViewBADriverInfoSales from '../../../components/Table/TableSliderViews/ViewBADriverInfoSales';
import useBaDriverVerification from '../../../hooks/dashboard/BaDriverVerification/useBaDriverVerification';
import useBaVerificationStatsCard from '../../../hooks/dashboard/BaDriverVerification/useBaVerificationStatsCard';

const BADriverVerificationTable = () => {
  const { toggleBADriverVerification: confirmDriver, loading: confirmLoading } =
    useBaDriverVerification();
  const { toggleBADriverVerification: rejectDriver, loading: rejectLoading } =
    useBaDriverVerification();
  const { getBaVerificationStats } = useBaVerificationStatsCard();

  useEffect(() => {
    getBaVerificationStats();
    // eslint-disable-next-line
  }, []);

  return (
    <Container>
      <PageHeader>OVERVIEW</PageHeader>

      <BAVerificationStatsCard />

      <Table
        tableTitle='DRIVER INFO LIST'
        tableFilterBoxFeatures={{
          showSearchBox: true,
          searchBoxPlaceholder: 'Search',
          rightAttr: [
            {
              type: 'filter',
              comp: <BAFilterForm />,
            },
            // {
            //   type: 'regular',
            //   comp: <ExportBaData />,
            // },
          ],
        }}
        tableHeader={{
          'Date Uploaded': 'createdAt',
          'Driver Name': 'firstName',
          'Phone No.': 'phoneNumber',
          NIN: 'nin',
          DOB: 'dateOfBirth',
          'Processing Status': 'status',
        }}
        tableDataSourceUrl='ba/v1/drivers/onboarding/get-paged-drivers'
        cellsCustomComp={{
          phoneNumber: <TablePhoneFormatter dataKey='phoneNumber' />,
          createdAt: <TableDateFormatter dataKey='createdAt' />,
          status: <StatusCell statusKey='status' hasDot />,
          firstName: (
            <TableFirstAndLastNameFormatter
              firstNameDataKey='firstName'
              lastNameDataKey='lastName'
            />
          ),
        }}
        moreOptionsComponents={[
          <ViewDetails
            key='View driver profile'
            label='View driver profile'
            width='200px'
            icon={<BADriverInfoIcon />}
            sliderCompFn={(data: any) => <ViewBADriverInfoSales data={data} />}
          />,
          <ActionRow
            key='Confirm profile'
            label='Confirm profile'
            width='200px'
            icon={
              confirmLoading ? <LoadingOutlined /> : <BAConfirmDriverIcon />
            }
            actionFn={async (data: any) => confirmDriver(data?.id, 'Confirmed')}
            freshTable={true}
            conditionalRenderFn={(data: any) => data?.status !== 'Pending'}
          />,
          <ActionRow
            key='Reject profile'
            label='Reject profile'
            width='200px'
            icon={rejectLoading ? <LoadingOutlined /> : <BARejectDriverIcon />}
            actionFn={async (data: any) => rejectDriver(data?.id, 'Rejected')}
            freshTable={true}
            conditionalRenderFn={(data: any) => data?.status !== 'Pending'}
          />,
          <ActionRowWithModal
            key='Indicate issue'
            label='Indicate issue'
            width='200px'
            icon={<ExclaimIcon />}
            modalCompFn={(data) => <IndicateIssuesModal data={data} />}
            conditionalRenderFn={(data: any) => data?.status !== 'Pending'}
          />,
          <ActionRowWithModal
            key='Re-confirm NIN'
            label='Re-confirm NIN'
            width='200px'
            icon={<ShieldIcon />}
            modalCompFn={(data) => <VerifyNINModal data={data} />}
            conditionalRenderFn={(data: any) =>
              data?.status !== 'Pending' && data?.status !== 'Rejected'
            }
          />,
        ]}
        mobileCellComp={<ViewBADriverInfoCell />}
      />
    </Container>
  );
};

export default BADriverVerificationTable;

const PageHeader = styled.div`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #6b7280;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  /* border: 1px solid red; */
  width: 100%;
`;
